/**
 * Read a `text/event-stream` fetch Response and call `onEvent(json)` for every
 * `data: {...}` frame. Resolves when the stream ends; rejects on a read error
 * (an aborted fetch rejects with an AbortError, as usual). Heartbeat `ping`
 * frames are skipped so callers only see real events.
 */
export async function readSseStream(response, onEvent) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop(); // keep the incomplete tail
    for (const part of parts) {
      const trimmed = part.trim();
      if (!trimmed.startsWith("data:")) continue;
      let data;
      try {
        data = JSON.parse(trimmed.slice(5).trim());
      } catch {
        continue;
      }
      if (!data || data.type === "ping") continue;
      onEvent(data);
    }
  }
}
